const GENRE_FAMILIEFILM = "Familiefilm";

export { GENRE_FAMILIEFILM };
